import {
  WS_GET_PAYPAL_LOGIN_URL_REQUEST,
  WS_GET_PAYPAL_LOGIN_URL_REQUEST_SUCCESS,
  WS_GET_PAYPAL_USER_DATA_REQUEST,
  WS_GET_PAYPAL_USER_DATA_REQUEST_SUCCESS,
  WS_GET_PAYPAL_REQUEST_ERROR,
} from '../actions';

export const initialState = {
  isFetchingUrl: false,
  error: '',
  url: null,
  user: null,
};

export const paypalConnect = (state = initialState, action) => {
  switch (action.type) {
    case WS_GET_PAYPAL_LOGIN_URL_REQUEST:
      return {
        isFetchingUrl: true,
        url: null,
        user: null,
        error: '',
      };
    case WS_GET_PAYPAL_LOGIN_URL_REQUEST_SUCCESS:
      return {
        isFetchingUrl: false,
        url: action.payload,
        user: null,
        error: '',
      };
    case WS_GET_PAYPAL_USER_DATA_REQUEST:
      return {
        isFetching: true,
        user: null,
        error: '',
      };
    case WS_GET_PAYPAL_USER_DATA_REQUEST_SUCCESS:
      return {
        isFetching: false,
        user: action.payload,
        error: '',
      };
    case WS_GET_PAYPAL_REQUEST_ERROR:
      return {
        isFetching: false,
        user: null,
        error: action.payload,
      };
    default:
      return state;
  }
};
